import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LineOfBusinessCardComponent } from './line-of-business-card.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    LineOfBusinessCardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    RouterModule,
  ],
  exports: [
    LineOfBusinessCardComponent
  ]
})
export class LineOfBusinessCardModule { }
